module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-1@3x__75b23eee5ee9f72e82cf6aaa5e5c25f0.png";